import { CaretRightFilled } from "@ant-design/icons";
import { Breadcrumb } from "antd";
import useNavigateToHome from "hooks/useNavigateToHome";
import { memo, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useMatches, Link, useParams } from "react-router";
import { compareWithJSON } from "utils/helper";

const Breadcrumbs = () => {
  const { id } = useParams();
  const { t } = useTranslation();
  const matches = useMatches();
  const navigateToHome = useNavigateToHome();
  const items = useMemo(() => {
    // Filter out root path and empty pathnames
    const filteredMatches = matches
      .filter((match) => match.pathname !== "/" && match.pathname !== "")
      .map((match) => ({
        pathname: match.pathname,
        params: match.params,
      }));

    // Memisahkan pathname menjadi segmen-segmen untuk breadcrumb bertingkat
    const breadcrumbItems = [];
    let currentPath = "";

    // Pisahkan pathname menjadi segmen-segmen
    let allSegments = (
      filteredMatches[filteredMatches.length - 1]?.pathname
        .split("/")
        .filter(Boolean) || []
    ).filter(
      (item) =>
        !Object.values(
          filteredMatches[filteredMatches.length - 1]?.params
        ).includes(item)
    );

    if (allSegments.includes("ticketing") && allSegments.includes("filter")) {
      allSegments = allSegments.filter((item) => item !== "filter");
    }

    const lastIndex = allSegments.length - 1;
    allSegments.forEach((segment, index) => {
      currentPath += `/${segment}`;
      if (segment === "ticketing") {
        currentPath = `/ticketing/${id}`;
      }
      const isLasts = index === lastIndex;
      const title = t(segment);

      breadcrumbItems.push({
        title: isLasts ? (
          <span className="px-1">{title}</span>
        ) : (
          <Link to={currentPath}>{title}</Link>
        ),
        className: "breadcrumb-item-link",
      });
    });

    // // Ubah link terakhir menjadi teks biasa
    // if (breadcrumbItems.length > 0) {
    //   const lastItem = breadcrumbItems[breadcrumbItems.length - 1];
    //   lastItem.title = formatPathname(allSegments[allSegments.length - 1]);
    // }

    return [
      {
        title: <Link onClick={navigateToHome}>Home</Link>,
        className: " breadcrumb-item-link",
      },
      ...breadcrumbItems,
    ];
  }, [matches, navigateToHome, t, id]);

  return (
    <Breadcrumb
      className="flex w-full items-center text-base container-breadcrumb"
      separator={
        <CaretRightFilled className="inline-flex items-center justify-center text-primary translate-y-[1px]" />
      }
      items={items}
    />
  );
};

export default memo(Breadcrumbs, compareWithJSON);
